<template>
  <div class="prepaidCustomerBillOfLading" v-loading="loading">
    <div class="caozuo">
      <el-button @click="is_shai = true">筛选</el-button>
      <el-button
        type="warning"
        @click="fenClick"
        v-if="$cookies.get('auth_grade') == 80 && !is_fen && activeName == '1'"
        >分配</el-button
      >
      <el-select
        clearable
        multiple
        v-if="$cookies.get('auth_grade') == 80 && is_fen"
        v-model="agent_staff"
        placeholder="请选择分配员工"
      >
        <el-option
          v-for="item in agent_saff"
          :key="item.staff_id"
          :label="item.staff_name"
          :value="item.staff_id"
        >
        </el-option>
      </el-select>
      <el-button
        @click="
          is_fen = false;
          agent_staff = [];
        "
        v-if="$cookies.get('auth_grade') == 80 && is_fen"
        >取 消</el-button
      >
      <el-button
        type="danger"
        @click="fenYES"
        v-if="$cookies.get('auth_grade') == 80 && is_fen"
        >确 定</el-button
      >
      <el-button
        type="primary"
        v-if="['100', '61'].indexOf($cookies.get('auth_grade')) == -1"
        @click="create"
        style="float: right"
        >创建提单</el-button
      >
    </div>
    <div class="conent">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="提单列表" name="0">
          <el-table
            :data="tableData"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="45"
              v-if="$cookies.get('auth_grade') == 80"
            >
            </el-table-column>
            <el-table-column
              prop="company_name"
              label="状态"
              width="180"
              v-if="
                ['100', '61'].indexOf($cookies.get('auth_grade')) == -1 &&
                activeName != 1
              "
            >
              <template slot-scope="scope">
                <div>
                  <el-tag v-if="scope.row.check_status == 0">待审核</el-tag>
                  <el-tag v-if="scope.row.check_status == 2" type="warning"
                    >被驳回</el-tag
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="company_name" label="公司名称" width="180">
            </el-table-column>

            <el-table-column prop="client_name" label="姓名"> </el-table-column>
            <el-table-column prop="client_phone" label="账号">
            </el-table-column>
            <el-table-column prop="staff_name" label="提单人">
            </el-table-column>
            <el-table-column prop="agent_staff_name_list" label="可查看人">
              <template slot-scope="scope">
                <div
                  v-for="(item, key) in scope.row.agent_staff_name_list.slice(
                    1,
                    scope.row.agent_staff_name_list.length
                  )"
                  :key="key"
                >
                  {{ item }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="aa" label="客户开通地区">
              <template slot-scope="scope">
                <div v-if="scope.row.place_data.province_name">
                  {{ scope.row.place_data.province_name }} -
                  {{ scope.row.place_data.city_name }} -
                  {{ scope.row.place_data.district_name }}
                </div>
                <div v-else>
                  {{ scope.row.place_data.city_name }} -
                  {{ scope.row.place_data.district_name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="aa" label="营业执照">
              <template slot-scope="scope">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="scope.row.license_img_url"
                  :preview-src-list="[scope.row.license_img_url]"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="客户公司行业">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.industry_data.first_industry_name }} -
                  {{ scope.row.industry_data.second_industry_name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="驳回原因"> </el-table-column>
            <el-table-column
              prop="agent_company"
              label="代理商公司名称"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="update_time_str"
              label="更新时间"
              width="180"
            >
            </el-table-column>

            <el-table-column prop="aa" label="操作" fixed="right">
              <template slot-scope="scope">
                <div>
                  <el-button
                    v-if="
                      ['100', '61'].indexOf($cookies.get('auth_grade')) == -1 &&
                      scope.row.check_status == 2
                    "
                    type="warning"
                    @click="editClick(scope.row)"
                    >修改</el-button
                  >
                  <el-button
                    v-if="
                      ['100', '61'].indexOf($cookies.get('auth_grade')) > -1
                    "
                    type="primary"
                    @click="
                      is_prompt = true;
                      elite_phone = scope.row.client_phone;
                      prompt_value = '';
                    "
                    >审核</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="已通过" name="1">
          <el-table
            :data="tableData"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="45"
              v-if="$cookies.get('auth_grade') == 80"
            >
            </el-table-column>
            <el-table-column
              prop="company_name"
              label="状态"
              width="180"
              v-if="
                ['100', '61'].indexOf($cookies.get('auth_grade')) == -1 &&
                activeName != 1
              "
            >
              <template slot-scope="scope">
                <div>
                  <el-tag v-if="scope.row.check_status == 0">待审核</el-tag>
                  <el-tag v-if="scope.row.check_status == 2" type="warning"
                    >被驳回</el-tag
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="company_name" label="公司名称" width="180">
            </el-table-column>

            <el-table-column prop="client_name" label="姓名"> </el-table-column>
            <el-table-column prop="client_phone" label="账号">
            </el-table-column>
            <el-table-column prop="staff_name" label="提单人">
            </el-table-column>
            <el-table-column prop="agent_staff_name_list" label="可查看人">
              <template slot-scope="scope">
                <div
                  v-for="(item, key) in scope.row.agent_staff_name_list.slice(
                    1,
                    scope.row.agent_staff_name_list.length
                  )"
                  :key="key"
                >
                  {{ item }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="aa" label="客户开通地区">
              <template slot-scope="scope">
                <div v-if="scope.row.place_data.province_name">
                  {{ scope.row.place_data.province_name }} -
                  {{ scope.row.place_data.city_name }} -
                  {{ scope.row.place_data.district_name }}
                </div>
                <div v-else>
                  {{ scope.row.place_data.city_name }} -
                  {{ scope.row.place_data.district_name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="aa" label="营业执照">
              <template slot-scope="scope">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="scope.row.license_img_url"
                  :preview-src-list="[scope.row.license_img_url]"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="客户公司行业">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.industry_data.first_industry_name }} -
                  {{ scope.row.industry_data.second_industry_name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="驳回原因"> </el-table-column>
            <el-table-column
              prop="agent_company"
              label="代理商公司名称"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="update_time_str"
              label="更新时间"
              width="180"
            >
            </el-table-column>
            <el-table-column label="跟进记录" width="180">
              <template slot-scope="scope">
                <el-button
                  v-if="['100', '61'].indexOf($cookies.get('auth_grade')) == -1"
                  type="text"
                  @click="followClick(scope.row.recharge_id)"
                  >跟进记录</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="aa" label="操作" fixed="right">
              <template slot-scope="scope">
                <div>
                  <el-button
                    type="warning"
                    @click="
                      () => {
                        $router.push({
                          path: 'recruitmentData',
                          query: {
                            id: scope.row.user_detail_id,
                            name: scope.row.company_name,
                          },
                        });
                      }
                    "
                    >数据看板</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="page">
      <el-pagination
        hide-on-single-page
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="15"
        :current-page="page + 1"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="充值账号提单"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form label-width="120px" class="demo-ruleForm" :show-message="false">
        <el-form-item label="公司名称" required>
          <el-input v-model="ruleForm.company_name"></el-input>
        </el-form-item>
        <el-form-item label="姓名" required>
          <el-input v-model="ruleForm.client_name"></el-input>
        </el-form-item>
        <el-form-item label="账号" required>
          <el-input
            type="number"
            oninput="if(value.length>5)value=value.slice(0,11)"
            v-model="ruleForm.client_phone"
          ></el-input>
        </el-form-item>

        <el-form-item label="客户开通地区" required>
          <el-cascader
            class="input"
            v-model="place_value"
            :options="place_data"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="客户公司行业">
          <el-cascader
            class="input"
            v-model="industry_value"
            :options="industry_data"
            :props="{ value: 'industry_id', label: 'name' }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="营业执照" required>
          <el-upload
            class="avatar-uploader"
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            :show-file-list="false"
            :on-success="success_zhizhao"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <span style="font-size: 12px; color: #f00; margin-right: 12px"
          >点击确定按钮后订单会自动提交，请仔细检查</span
        >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="billYes">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审核"
      :visible.sync="is_prompt"
      width="30%"
      :before-close="
        () => {
          is_prompt = false;
        }
      "
    >
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入审核备注"
        v-model="prompt_value"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="promptYes('false')">不通过</el-button>
        <el-button type="primary" @click="promptYes('true')">通 过</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="跟进记录"
      :visible.sync="is_follow"
      width="30%"
      :before-close="
        () => {
          is_follow = false;
        }
      "
    >
      <div>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入跟进记录"
          v-model="follow_detail"
        >
        </el-input>
        <div class="follow_list">
          <p v-for="(item, key) in follow_list" :key="key">
            <span>
              {{ item.create_time_str }}
            </span>
            -

            <span>{{ item.staff_name }} </span>

            填写了 <span>{{ item.follow_detail }}</span>
          </p>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="FollowYes('false')">取 消</el-button>
        <el-button type="primary" @click="FollowYes('true')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="充值账号信息"
      :visible.sync="is_zhongzhi"
      width="30%"
      :before-close="
        () => {
          is_zhongzhi = false;
        }
      "
    >
      <div>
        <h3 style="color: red">
          该账号已存在，点击确认将覆盖账号信息，是否确认?
        </h3>
        <el-table :data="tableDatachongz" style="width: 100%">
          <el-table-column prop="username" label="帐号"></el-table-column>
          <el-table-column
            prop="contact_name"
            label="联系人姓名"
          ></el-table-column>
          <el-table-column
            prop="license_company_name"
            label="公司名称"
          ></el-table-column>
          <el-table-column prop="is_seed" label="充值客户">
            <template slot-scope="scope">{{
              scope.row.is_seed ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column prop="is_experience" label="体验客户">
            <template slot-scope="scope">{{
              scope.row.is_experience == "1" ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column prop label="公司行业">
            <template slot-scope="scope">{{
              scope.row.industry_name.second_industry_name
            }}</template>
          </el-table-column>

          <el-table-column prop label="公司所在地">
            <template slot-scope="scope">
              {{ scope.row.place_data.city_name }}-{{
                scope.row.place_data.district_name
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="agent_name"
            label="直销、代理商"
          ></el-table-column>
          <el-table-column prop="is_agent" label="是否代理商">
            <template slot-scope="scope">
              {{ scope.row.is_agent ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column prop="is_province_agent" label="是否省代">
            <template slot-scope="scope">
              {{ scope.row.is_province_agent ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column prop="is_province_agent" label="是否关闭">
            <template slot-scope="scope">
              <el-tag :type="scope.row.is_expire ? 'success' : 'danger'">
                {{ scope.row.is_expire ? "是" : "否" }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="account_access" label="开通权限">
            <template slot-scope="scope">
              {{ scope.row.account_access ? "微信和抖音" : "微信" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="vip_start_time_str"
            label="会员开始时间"
          ></el-table-column>
          <el-table-column
            prop="vip_end_time_str"
            label="会员到期时间"
          ></el-table-column>
          <el-table-column prop="jd_audit" label="职位承诺书"></el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="zhongzhi('3')">取消</el-button>
        <el-button type="primary" @click="zhongzhi('1')">确认覆盖</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="筛选"
      :visible.sync="is_shai"
      width="30%"
      :before-close="
        () => {
          is_shai = false;
        }
      "
    >
      <el-form :model="shai_form" label-width="100px">
        <el-form-item label="公司名称">
          <el-input v-model="shai_form.company_name__contains"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="shai_form.client_name"></el-input>
        </el-form-item>
        <el-form-item label="账号">
          <el-input
            type="number"
            oninput="if(value.length>5)value=value.slice(0,11)"
            v-model="shai_form.client_phone"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="筛选代理商"
          v-if="['100', '61'].indexOf($cookies.get('auth_grade')) > -1"
        >
          <el-select v-model="shai_form.agent_username" placeholder="请选择">
            <el-option
              v-for="item in agent_username"
              :key="item.staff_id"
              :label="item.agent_company_name"
              :value="item.username"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户开通地区">
          <el-cascader
            class="input"
            v-model="place"
            :options="place_data"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="筛选员工">
          <el-select
            v-if="$cookies.get('auth_grade') == 80"
            v-model="shai_form.lufish_agent_staff__contains"
            placeholder="请选择筛选的员工"
          >
            <el-option
              v-for="item in agent_saff"
              :key="item.staff_id"
              :label="item.staff_name"
              :value="item.staff_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            is_shai = false;
            shai_form = {};
            place = '';
            init();
          "
          >取消</el-button
        >
        <el-button type="primary" @click="init">筛选</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { require, url_Api } from "@/utils/http_request.js";
import axios from "axios";

export default {
  name: "prepaidCustomerBillOfLading",
  //组件引入
  components: {},
  //状态存储
  data() {
    return {
      activeName: "0",
      tableData: [],
      total: 0,
      ruleForm: {},
      dialogVisible: false,
      imageUrl: "",
      license: "",
      url_Api: url_Api,
      place_data: [],
      industry_data: [],
      agent_data: [],
      agent_value: [],
      place_value: [],
      industry_value: [],
      page: 0,
      loading: true,
      check_status: 0,
      is_prompt: false,
      prompt_value: "",
      elite_phone: "",
      tableDatachongz: [],
      is_zhongzhi: false,
      label_code: "create",
      recharge_id: "",
      is_shai: false,
      shai_form: {},
      place: "",
      agent_username: [],
      multipleSelection: [],
      is_fen: false,
      agent_saff: [],
      is_follow: false,
      staff_id: "",
      follow_detail: "",
      follow_list: [],
      agent_staff: [],
    };
  },
  //计算属性
  computed: {},
  //状态监听
  watch: {},
  //存放方法集合
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    create() {
      this.ruleForm = {
        client_phone: "",
        company_name: "",
        client_name: "",
      };
      this.license = "";
      this.imageUrl = "";
      this.place_value = [];
      this.industry_value = [];
      this.dialogVisible = true;
      this.check_status = 0;
      this.label_code = "create";
    },
    handleClick() {
      this.page = 0;
      this.$cookies.set(
        "prepaid",
        JSON.stringify({
          activeName: this.activeName,
          page: this.page,
        })
      );

      this.shai_form = {};
      this.place = [];

      this.init();
    },
    promptYes(is_add) {
      if (is_add == "true") {
        let search_data = {
          search_data: {
            username: this.elite_phone,
          },
        };
        require("post", "/hr24_user/v1/search_user_info/", search_data).then(
          (res) => {
            if (!res.code) {
              if (res.data.length > 0) {
                this.tableDatachongz = res.data;
                this.is_zhongzhi = true;
              }
            }
            if (res.code == "203011202") {
              check_recharge_client();
            }
          }
        );
      } else {
        require("POST", "/lufish_sale/v1/check_recharge_client/", {
          client_phone: this.elite_phone,
          check_status: 2,
          remark: this.prompt_value,
        }).then((res) => {
          console.log(res);
          if (!res.code) {
            this.is_prompt = false;
            this.page = 0;
            this.init();
            this.dialogVisible = false;
          } else {
            this.$message.warning(res.msg);
          }
        });
      }
      let check_recharge_client = () => {
        require("POST", "/lufish_sale/v1/check_recharge_client/", {
          client_phone: this.elite_phone,
          check_status: 1,
          remark: this.prompt_value,
        }).then((res) => {
          console.log(res);
          if (!res.code) {
            this.is_prompt = false;
            this.page = 0;
            this.init();
            this.dialogVisible = false;
          } else {
            this.$message.warning(res.msg);
          }
        });
      };
    },
    followClick(id) {
      require("POST", "/lufish_sale/v1/recharge_client_follow_list/", {
        recharge_id: id,
      }).then((res) => {
        if (!res.code) {
          this.follow_list = res.data;
          this.is_follow = true;
          this.staff_id = id;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    fenClick() {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择要分配的提单");
        return;
      }
      this.is_fen = true;
    },
    fenYES() {
      if (this.agent_staff.length == 0) {
        this.$message.warning("请选择分配人");
        return;
      }
      console.log(this.multipleSelection);
      let multipleSelection = [];
      this.multipleSelection.forEach((item) => {
        multipleSelection.push(item.recharge_id);
      });
      require("POST", "/lufish_sale/v1/recharge_client_allocation/", {
        recharge_id_list: JSON.stringify(multipleSelection),
        agent_staff: this.agent_staff.toString(),
      }).then((res) => {
        if (!res.code) {
          this.$message.success("分配成功");
          this.is_fen = false;
          this.agent_staff = [];
          this.init();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    FollowYes(is_add) {
      if (is_add) {
        if (this.follow_detail) {
          require("POST", "/lufish_sale/v1/recharge_client_follow/", {
            recharge_id: this.staff_id,
            follow_detail: this.follow_detail,
          }).then((res) => {
            if (!res.code) {
              this.$message.success("创建成功");
              this.is_follow = false;
              this.follow_detail = "";
            } else {
              this.$message.warning(res.msg);
            }
          });
        } else {
          this.$message.warning("请填写跟进记录");
        }
      } else {
        this.is_follow = false;
      }
    },
    zhongzhi(is_cs) {
      if (is_cs == "1") {
        console.log("queding");
        require("POST", "/lufish_sale/v1/check_recharge_client/", {
          client_phone: this.elite_phone,
          check_status: 1,
          remark: this.prompt_value,
        }).then((res) => {
          console.log(res);
          if (!res.code) {
            this.is_prompt = false;
            this.page = 0;
            this.init();
            this.dialogVisible = false;
            this.is_zhongzhi = false;
          } else {
            this.$message.warning(res.msg);
          }
        });
      } else {
        console.log("更新取消");
        this.is_prompt = false;
        this.is_zhongzhi = false;
      }
    },
    currentChange(page) {
      console.log("page", page);
      this.page = page - 1;
      this.$cookies.set(
        "prepaid",
        JSON.stringify({
          activeName: this.activeName,
          page: this.page,
        })
      );
      this.init();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    success_zhizhao(file) {
      // 图片参数
      console.log(file);
      this.license = file.data.file_data.file_id;
      // 展示图片变量
      this.imageUrl = file.data.file_data.file_url;
    },

    beforeAvatarUpload(file) {
      console.log("file", file);
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt10M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isLt10M && isJPG;
    },
    editClick(data) {
      this.$set(this.ruleForm, "client_phone", data.client_phone);
      this.$set(this.ruleForm, "company_name", data.company_name);
      this.$set(this.ruleForm, "client_name", data.client_name);
      this.check_status = JSON.parse(JSON.stringify(data.check_status));
      this.recharge_id = data.recharge_id;
      if (data.place_data.province_code) {
        this.place_value = [
          data.place_data.province_code,
          data.place_data.city_code,
          data.place_data.district_code + "",
        ];
      } else {
        this.place_value = [
          data.place_data.city_code,
          data.place_data.city_code,
          data.place_data.district_code + "",
        ];
      }

      this.industry_value = [
        data.industry_data.first_industry_id,
        data.industry_data.second_industry_id,
      ];
      this.license = data.license_img;
      // 展示图片变量
      this.imageUrl = data.license_img_url;
      this.label_code = "update";
      this.dialogVisible = true;
    },
    billYes() {
      let index = 0;
      for (let key in this.ruleForm) {
        if (this.ruleForm[key] == "" || this.ruleForm[key] == 0) {
          index++;
        }
      }
      if (this.place_value.length == 0 || this.license == "") {
        index++;
      }
      if (this.ruleForm.client_phone.length != 11) {
        this.$message.warning("账号有误");
        return false;
      }
      console.log(
        this.ruleForm,
        this.agent_value,
        this.place_value,
        this.license
      );
      if (index > 0) {
        this.$message.warning("请选择必填字段");
        return;
      }

      let industry = "";
      if (this.industry_value.length > 0) {
        industry = this.industry_value[1] || 0;
      }
      let obj = {
        client_data: {
          company_name: this.ruleForm.company_name,
          client_name: this.ruleForm.client_name,
          client_phone: this.ruleForm.client_phone,
          province_id: this.place_value[0],
          city_id: this.place_value[1],
          district_id: this.place_value[2],
          industry,
          license_img: this.license,
          check_status: 0,
        },
        label_code: this.label_code,
        agent_username: this.$cookies.get("agent_username"),
      };
      if (this.label_code == "update") {
        obj.recharge_id = this.recharge_id;
      }
      require("POST", "/lufish_sale/v1/recharge_client/", obj).then((res) => {
        console.log(res);
        if (!res.code) {
          this.page = 0;
          this.init();
          this.dialogVisible = false;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    init() {
      console.log("iniiii");
      if (this.$cookies.get("prepaid") != null) {
        console.log(this.$cookies.get("prepaid"));
        let prepaid = this.$cookies.get("prepaid");
        this.page = prepaid.page;
        this.activeName = prepaid.activeName;
      }
      this.loading = true;
      let obj = {
        recharge_status: this.activeName,
        page: this.page,
      };
      if (JSON.stringify(this.shai_form) != "{}") {
        obj.search_data = {
          ...this.shai_form,
        };
      }
      if (this.shai_form) {
        obj.search_data = { ...this.shai_form };
      }
      if (this.place.length == 3) {
        if (this.place[2] == this.place[1]) {
          obj.search_data.city_id = this.place[1];
        } else {
          obj.search_data.district_id = this.place[2];
        }
      }
      require("POST", "/lufish_sale/v1/recharge_client_list/", obj).then(
        (res) => {
          console.log(res);
          if (!res.code) {
            this.tableData = res.data;
            this.total = res.count;
            this.loading = false;
            this.is_shai = false;
          } else {
            this.$message.warning(res.msg);
          }
        }
      );
    },
    show_place_json() {
      require("post", "/commonality/v1/show_place_json/", { is_add: 1 }).then(
        (res) => {
          console.log(res);
          if (res.code == 0) {
            this.place_data = res.data;
          }
        }
      );
      axios.get("/static/json/industry.json").then((res) => {
        this.industry_data = res;
      });
      require("post", "/hr24_user/v1/show_agent_city/", {}).then((res) => {
        console.log("res", res);
        this.agent_data = res.data;
      });
      require("post", "/lufish_sale/v1/all_agent_user/", {}).then((res) => {
        console.log("res", res);
        this.agent_username = res.data;
      });
      require("post", "/lufish_sale/v1/all_agent_user/", {
        is_agent: 4,
      }).then((res) => {
        console.log("res", res);
        this.agent_saff = res.data;
      });
    },
  },
  //数据初始化之后
  created() {
    this.init();
    this.show_place_json();
  },
  //页面渲染之后
  mounted() {},
  //数据初始化之前
  beforeCreate() {},
  //页面渲染之前
  beforeMount() {},
  //状态更新之前
  beforeUpdate() {},
  //状态更新之后
  updated() {},
  //页面卸载之前
  beforeDestroy() {},
  //卸载之后
  destroyed() {},
  //页面进入   页面缓存时有效
  activated() {},
};
</script>
<style  scoped>
.prepaidCustomerBillOfLading {
  position: relative;
  width: calc(100% - 209px);
  left: 181px;
  top: 68px;
  padding: 14px;
  min-height: 80vh;
  background: #fff;
}
.caozuo {
  padding: 12px 0px;
  /* text-align: right; */
  overflow: hidden;
}
.page {
  text-align: center;
  padding: 12px 0;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 146px;
  height: 146px;
  line-height: 120px;
  text-align: center;
  position: relative;
  /* padding-top: 100px; */
  top: 0px;
  border: #8c939d dashed 1px;
  border-radius: 5px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 30px;
  color: #8c939d;
  width: 146px;
  height: 146px;
  line-height: 146px;
  text-align: center;
}
.avatar {
  width: 146px;
  height: 146px;
  display: block;
}
.input {
  width: 100%;
}
.follow_list > p {
  font-size: 14px;
  font-weight: bold;
  position: relative;
  margin: 0 20px;
  line-height: 30px;
}
.follow_list > p::before {
  content: ".";
  display: block;
  font-size: 30px;
  font-weight: bold;
  position: absolute;
  top: -8px;
  left: -20px;
  color: #ff8f40;
}
.follow_list > p > span {
  margin-right: 12px;
  color: #ff8f40;
}
</style>



// WEBPACK FOOTER //
// src/recharge_management/prepaidCustomerBillOfLading.vue